var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25945 21.9777C7.51005 23.4391 8.76764 24.4995 10.2497 24.4995C11.7321 24.4995 12.9901 23.4391 13.2407 21.9777L13.256 21.8887H7.24414L7.25945 21.9777Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.48 17.7998C20.2347 17.5544 19.9848 17.347 19.743 17.1461C18.726 16.3016 17.8477 15.5724 17.8477 12.5443V10.1425C17.8477 6.61065 15.3662 3.51159 11.9328 2.73457C12.0704 2.46469 12.1401 2.18103 12.1401 1.88975C12.1401 0.847834 11.2923 0 10.25 0C9.20794 0 8.3602 0.847834 8.3602 1.88975C8.3602 2.18122 8.42988 2.46483 8.56759 2.73457C5.134 3.51159 2.65266 6.61065 2.65266 10.1425V12.5443C2.65266 15.5724 1.7743 16.3017 0.757355 17.1461C0.515609 17.3469 0.265633 17.5544 0.0203457 17.7998L-0.00195312 17.8221V20.205H20.5023V17.8221L20.48 17.7998Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRing);
export default __webpack_public_path__ + "static/media/icon_ring.d2fa81ab2f973e1c7c7338a89002d2f6.svg";
export { ForwardRef as ReactComponent };